<template>
  <div class="login" :style="'height: ' + height + 'px;'">
    <LoginForm :type="'static'"></LoginForm>
  </div>
</template>

<script>
import LoginForm from "@/components/GlobalComponent/Login/LoginForm";

var glob;

export default {
  name: "Login_Page",
  components: {
    LoginForm,
  },
  data() {
    return {
      height: 0,
    };
  },
  mounted() {
    glob = this;
    this.height = window.innerHeight;

    window.onresize = () => {
      glob.height = window.innerHeight;
    };
  },
  methods: {},
};
</script>

<style lang="scss">
.login {
  @include flex(row, center, center);
  width: 100vw;

  @media #{$breakpoint-down-sm} {
    align-items: center;
    overflow-y: auto;
  }
}
</style>